import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import config from '../../config';

import AdminImportPage from '../shared/adminImportPage.component';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';

import { withPermissions, permissions } from '../../shared/authorization';

import {
  sharedActions,
} from './store/actions';
import { glJournalsSelector } from './store/selectors';
import AddEditModal from './addEditModal.component';
import DeleteModal from './deleteModal.component';
import AdminColumnRenderer from './adminColumnRenderer.component';
import columnDefinitions from '../../shared/columnDefinitions/glJournals';
import downloadXlsx from './downloadXlsx';

const ConnectedGlJournals = ({
  canModifyInSelectedPeriod,
}) => {
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Balance_Sheet_Management_GL_Journal_${periodName}`,
    []);

  const glJournalComparator = useCallback((journal, importedJournal) =>
    journal.countryTaxType === importedJournal.countryTaxType
    && journal.type === importedJournal.type
    && journal.activity === importedJournal.activity
    && journal.slAccount === importedJournal.slAccount
  , []);

  return (
    <AdminImportPage
      pageName={adminPageNames.GL_JOURNALS}
      canModify={canModifyInSelectedPeriod}
      AddEditEntityModal={AddEditModal}
      RemoveEntityModal={DeleteModal}
      adminColumnRenderer={AdminColumnRenderer}
      addEntityMessage="Add GL Journal"
      columnDefs={columnDefinitions}
      actions={sharedActions}
      exportToExcel={downloadXlsx}
      templatePath={config.templates.GL_JOURNALS}
      generateTemplateFileName={generateTemplateFileName}
      comparatorConfig={{
        idField: 'countryTaxType',
        idFieldComparator: glJournalComparator,
      }}
      pageTitle={adminPageTitles.GL_JOURNALS}
      entitiesSelector={glJournalsSelector}
    />
  );
};

ConnectedGlJournals.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};

export default withPermissions(permissions.GL_JOURNALS_PAGE)(ConnectedGlJournals);
